export enum ContractAddToCartPopupStates {
  LOADING,
  ERROR_LOADING,
  LOADED,
  SENDING,
  SEND_SUCCESS,
  SEND_FAILURE,
}
